export const SEND_RESULT_RATING_MAIL_REQUEST = 'SEND_RESULT_RATING_MAIL_REQUEST';

export const sendResultRatingMailRequest = ({ module }) => ({
    type: SEND_RESULT_RATING_MAIL_REQUEST,
    payload: {
        module,
    }
});
